import { Button, Intent, Tag } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

const AddPageButton = ({ icon, label, count, disabled, onClick }) => {
  return (
    <Button
      disabled={disabled}
      icon={icon}
      // rightIcon={count != null && <Tag>{count}</Tag>}
      intent={Intent.PRIMARY}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

AddPageButton.defaultProps = {
  count: undefined,
  icon: 'plus',
  label: 'Add Page(s)',
  disabled: false,
  onClick: () => {},
};

AddPageButton.propTypes = {
  count: PropTypes.number,
  icon: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AddPageButton;
